/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect, useRef, useState } from 'react';
import { Spinner, View, VIEW_ALIGN, VIEW_DISTRIBUTION, VIEW_BG_VIEW, Modal } from '@veeam/components';

export interface PortalSpinnerProps {
    whiteBg?: boolean;
    delayTime?: number;
    size?: number;
}

export const PortalSpinner: React.FC<PortalSpinnerProps> = ({ whiteBg = false, delayTime = 0, size = 48 }) => {
    const isDelayActive = delayTime > 0;
    const [isShowSpinner, setIsShowSpinner] = useState(!isDelayActive);
    const timerIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (isDelayActive && timerIdRef.current === null) {
            timerIdRef.current = window.setTimeout(() => {
                setIsShowSpinner(true);
                timerIdRef.current = null;
            }, delayTime);
        }

        return () => {
            if (timerIdRef.current) {
                clearTimeout(timerIdRef.current);
                timerIdRef.current = null;
            }
        };
    }, [isDelayActive, delayTime]);

    return (
        isShowSpinner && (
            <>
                {!whiteBg && (
                    <Modal
                        isShown={true}
                        render={() => (
                            <View
                                size={{ width: '200px', height: '130px' }}
                                align={VIEW_ALIGN.center}
                                distribution={VIEW_DISTRIBUTION.center}
                                style={{ backgroundColor: '#fff', borderRadius: '3px' }}
                            >
                                <Spinner size={size} />
                            </View>
                        )}
                    />
                )}

                {whiteBg && (
                    <View
                        size={{ width: '100%', height: '100%' }}
                        align={VIEW_ALIGN.center}
                        distribution={VIEW_DISTRIBUTION.center}
                        backgroundView={VIEW_BG_VIEW.none}
                    >
                        <Spinner size={size} />
                    </View>
                )}
            </>
        )
    );
};
